import FooterNavbar from "../../../../footernavbar/FooterNavbar";
import AboutusNavbar from "../AboutusNavbar";

const Crs = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <AboutusNavbar />
        <div>
          <div>
            <div className="mt-3 py-3">
              <div className="row">
                <div className="container">
                  <div className="col-lg-12 justify-content-center text-center ">
                    <h1 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                      Corporate Responsibility & Sustainability
                      <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                    </h1>
                  </div>
                </div>
              </div>
              <div className="w-60 h-50 mx-auto mt-4">
                <div className="d-block blur-shadow-image">
                  <img
                    src="../../assets/img/footer/csr.jpg"
                    alt="img-blur-shadow-blog-2"
                    className="img-full "
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="row w-70 d-flex justify-content-center mx-auto pt-6">
              <section className="py-0">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="container col-lg-12 col-md-6 position-relative mb-sm-0 mb-3">
                      <h1 className="mb-3 text-black  fw-bold">
                      <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                        Corporate responsibility and sustainability mean doing
                        well by doing good for people and the planet.{" "}
                        <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                      </h1>
                      <p className="mb-3 fs-4 text-black">
                        At Sworld solutions private limited we believe that
                        business success goes hand-in-hand with responsibility
                        towards our planet and society. Our commitment to
                        Corporate Responsibility & Sustainability (CRS) is
                        ingrained in every facet of our operations, ensuring
                        that we not only meet the needs of our customers but
                        also contribute positively to the world around us.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                      <div className="mb-3">
                        <h2 className="mb-3 text-black fw-bold">
                          Ethical Sourcing and Supply Chain Integrity
                        </h2>
                        <p className="mb-3 fs-4 text-black">
                          We prioritize ethical sourcing practices by partnering
                          with suppliers who share our values of fair labor
                          conditions, ethical treatment of workers, and
                          environmental stewardship. By choosing sustainable
                          materials and supporting fair trade initiatives, we
                          ensure that every product sold on our platform meets
                          stringent ethical standards.
                        </p>
                      </div>
                      <div>
                        <h2 className="mb-3 text-black fw-bold ">
                          Environmental Stewardship
                        </h2>
                        <p className="mb-3 fs-4 text-black">
                          Reducing our environmental footprint is a cornerstone
                          of our sustainability strategy. We are dedicated to
                          minimizing packaging waste by using recyclable
                          materials and optimizing package sizes. Moreover, we
                          actively seek energy-efficient solutions in our
                          operations and logistics, striving to reduce carbon
                          emissions and promote renewable energy sources
                          wherever feasible.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-1"></div>
                    <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                      <img
                        className="w-100 border-radius-lg shadow"
                        src="../../assets/img/footer/environmental.jpeg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-5 col-6 mx-lg-0  px-lg-0 px-md-0 my-auto">
                      <img
                        className="w-100 border-radius-lg shadow"
                        src="../../assets/img/footer/customer-support.jpg"
                        alt=""
                      />
                    </div>
                    <div className="col-lg-1"></div>
                    <div className="col-lg-6 col-10 d-flex justify-content-center flex-column text-lg-start text-center">
                      <div className="mb-3">
                        <h2 className="mb-3 text-black fw-bold">
                          Community Engagement and Social Impact
                        </h2>
                        <p className="mb-3 fs-4 text-black">
                          Beyond business success, we are committed to making a
                          positive impact in our communities. Through
                          partnerships with local organizations and charitable
                          initiatives, we support causes that matter to our
                          customers and employees alike. By fostering a culture
                          of giving back, we aim to create meaningful change and
                          contribute to the well-being of society.
                        </p>
                      </div>
                      <div>
                        <h2 className="mb-3 text-black fw-bold">
                          Product Responsibility and Customer Trust
                        </h2>
                        <p className="mb-3 fs-4 text-black">
                          We take pride in the quality and safety of every
                          product offered on our platform. Our commitment to
                          product responsibility means rigorous testing for
                          safety and reliability, ensuring that our customers
                          can shop with confidence. We also provide transparent
                          information about product origins and environmental
                          impacts, empowering consumers to make informed
                          choices.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <section className="py-3">
                  <div className="container">
                    <div className="row justify-space-between py-2">
                      <div className="card card-plain card-blog mt-5">
                        <div className="row">
                          <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                            <h3 className="text-dark cursor-pointer">
                              {" "}
                              Empowering Our Team
                            </h3>
                            <p className="fs-5 text-black">
                              Our employees are at the heart of our
                              sustainability efforts. We prioritize a diverse
                              and inclusive workplace culture where every team
                              member has opportunities for growth and
                              development. By investing in their well-being and
                              professional advancement, we cultivate a motivated
                              workforce dedicated to achieving our CSR goals.
                            </p>
                          </div>
                          <div className="col-md-5">
                            <div className="card-image position-relative border-radius-lg cursor-pointer">
                              <div className="blur-shadow-image">
                                <img
                                  className="img border-radius-lg"
                                  src="../../assets/img/footer/empowering.jpg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="py-3">
                  <div className="container">
                    <div className="row justify-space-between py-2">
                      <div className="card card-plain card-blog mt-5">
                        <div className="row">
                          <div className="col-md-5">
                            <div className="card-image position-relative border-radius-lg cursor-pointer">
                              <div className="blur-shadow-image">
                                <img
                                  className="img border-radius-lg"
                                  src="../../assets/img/footer/accountablity.jpg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                            <h3 className="text-dark cursor-pointer">
                              {" "}
                              Transparency and Accountability
                            </h3>
                            <p className="fs-5 text-black">
                              We believe in transparency as a fundamental
                              principle of our CSR strategy. Through regular
                              reporting and communication, we share our
                              progress, challenges, and future ambitions with
                              our stakeholders. By holding ourselves
                              accountable, we strive to continuously improve and
                              innovate in our sustainability practices.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </section>
            </div>
            <section className="py-6">
              <div className="row">
                <div className="container">
                  <div className="col-lg-12 justify-content-center text-center ">
                    <h1 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                      Join Us in Making a Difference
                      <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                    </h1>
                    <h4 className=" text-black source-serif-4 text-normal mt-2">
                      <sup>
                        {" "}
                        <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-xs"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                      </sup>
                      At Sworld solutions private limited Corporate
                      Responsibility & Sustainability <br />
                      is not just a commitment—it’s a promise to do better, for
                      our planet, our communities, and future generations.{" "}
                      <br /> Join us on this journey towards a more sustainable
                      future by choosing Sworld solutions private limited Salar
                      for your ethical shopping needs. Together, we can make a
                      difference.
                      <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-xs"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="w-60 h-50 mx-auto mt-4">
                <div className="d-block blur-shadow-image">
                  <img
                    src="../../assets/img/footer/corpresponse.jpg"
                    alt="img-blur-shadow-blog-2"
                    className="img-full "
                    loading="lazy"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Crs;
